// frontend/src/components/ScientificDashboard/ReportViewer.tsx

import React from 'react';

type Props = {
  title: string;
  containerPath: string | null | undefined;
  datasetName?: string;
  version?: number;
  kind: 'business' | 'scientific';
};

/**
 * Converte o caminho do container (/app/registry/...) para URL servida
 * pelo Nginx do frontend (/registry/...).
 */
const toUrl = (p: string | null | undefined): string | null =>
  p ? p.replace(/^\/app\/registry/, '/registry') : null;

const buildDownloadName = (
  datasetName: string | undefined,
  version: number | undefined,
  kind: 'business' | 'scientific'
): string => {
  const ds = datasetName ?? 'dataset';
  const v = version != null ? `_v${String(version).padStart(4, '0')}` : '';
  const suffix = kind === 'business' ? '_business' : '_ml_report';
  return `${ds}${v}${suffix}.html`;
};

export const ReportViewer: React.FC<Props> = ({
  title,
  containerPath,
  datasetName,
  version,
  kind,
}) => {
  const url = toUrl(containerPath);

  if (!url) {
    return (
      <div
        style={{
          padding: '32px',
          textAlign: 'center',
          color: '#8899aa',
          background: 'rgba(10, 10, 26, 0.4)',
          borderRadius: '8px',
          border: '1px dashed #1a4a7a',
        }}
      >
        📄 Relatório não disponível para este dataset/versão.
      </div>
    );
  }

  const downloadName = buildDownloadName(datasetName, version, kind);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {/* Toolbar */}
      <div
        style={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          padding: '10px 14px',
          background: 'rgba(79, 195, 247, 0.08)',
          border: '1px solid #1a4a7a',
          borderRadius: '8px',
        }}
      >
        <span style={{ color: '#e0e0e0', fontSize: '14px', fontWeight: 500 }}>
          {title}
        </span>
        <div style={{ flex: 1 }} />
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          style={{
            color: '#4fc3f7',
            fontSize: '13px',
            textDecoration: 'none',
            padding: '6px 12px',
            border: '1px solid #4fc3f7',
            borderRadius: '6px',
          }}
        >
          🔗 Abrir em nova aba
        </a>
        <a
          href={url}
          download={downloadName}
          style={{
            color: '#66bb6a',
            fontSize: '13px',
            textDecoration: 'none',
            padding: '6px 12px',
            border: '1px solid #66bb6a',
            borderRadius: '6px',
          }}
        >
          ⬇️ Baixar HTML
        </a>
      </div>

      {/* Iframe */}
      <iframe
        title={title}
        src={url}
        style={{
          width: '100%',
          height: '80vh',
          border: '1px solid #1a4a7a',
          borderRadius: '8px',
          background: '#fff',
        }}
      />
    </div>
  );
};